import { useEffect, useState } from 'react'
import './FVSList.scss'
import { LocationSlice, changeProjectAction, getAuthInfoAction } from 'redux/reducers'
import { useDispatch } from 'react-redux'
import { getHashSearchParam } from 'utils'
import { useContextConsumer } from 'context/loginAuthProvider'
import { persistor } from 'redux/store'
import { getWeeklyProductionApi } from 'api'
import { LoadingOutlined } from '@ant-design/icons'

const FVSList = () => {
    const [tableDatas, setTableDatas] = useState([])
    const { loginLargeScreenMap, token } = useContextConsumer() // 登录权鉴
    const project_id = getHashSearchParam('project_id') // 无感登录
    const endDate = getHashSearchParam('endDate')
    const type = getHashSearchParam('type')
    const dispatch = useDispatch()
    const [isWait, setIsWait] = useState(false)

    useEffect(() => {
        if (!token) loginLargeScreenMap({ username: 'bgpmap@klseis.com', password: '.7;A|#VlA)JH' }) // if (!token) loginLargeScreenMap({ username: 'caoziliang', password: '123456' })
    }, [])

    /* 获取用户信息 */
    useEffect(() => {
        if (token) {
            dispatch(getAuthInfoAction())
        }
    }, [token])

    /* 大屏切换项目 */
    useEffect(async () => {
        if (!token) return
        if (project_id) {
            await dispatch(changeProjectAction(project_id)) // 发送请求，改变项目

            await persistor.purge() // 清除 redux 持久存储内容

            dispatch(LocationSlice.actions.clearLocation()) // 重置 location 狀態

            // const origin = window.location.origin

            // window.location.replace(origin + '/fvs_list') // 刷新网页，改变 url
        }
    }, [project_id, token])

    const cleanHtmlString = htmlString => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(htmlString, 'text/html')
        const listItems = doc.querySelectorAll('li')

        listItems.forEach(li => {
            const paragraphs = li.querySelectorAll('p')
            paragraphs.forEach(p => {
                const textNode = document.createTextNode(p.textContent)
                li.replaceChild(textNode, p)
            })
        })

        // 移除空p标签和空白节点
        const emptyPs = doc.querySelectorAll('p:empty')
        emptyPs.forEach(p => p.remove())

        return doc.body.innerHTML
    }

    // 回显用户自定义输入数据
    useEffect(async () => {
        if (!project_id || !token) return
        const result = await getWeeklyProductionApi(project_id)
        const plannedData = result?.data?.data
        const summaryData = plannedData?.find(item => item?.produceDate === endDate)?.[type]
        setTableDatas(summaryData)
        setIsWait(true)
    }, [project_id, token])

    return isWait ? (
        <div className='FVSList' dangerouslySetInnerHTML={{ __html: cleanHtmlString(tableDatas) }}></div>
    ) : (
        <div className='FVSList'>
            <LoadingOutlined style={{ position: 'relative', top: '10px', left: '10px', fontSize: '20px' }} />
        </div>
    )
}

export default FVSList
